import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M20.249 4.143h-16.5a2.766 2.766 0 00-2.75 2.75v10.214a2.766 2.766 0 002.75 2.75h16.5a2.766 2.766 0 002.75-2.75V6.893a2.766 2.766 0 00-2.75-2.75zM19.463 17.5h-1.571a1.178 1.178 0 110-2.357h1.571a1.178 1.178 0 110 2.357zm1.179-7.465a1.195 1.195 0 01-1.179 1.179H4.535a1.194 1.194 0 01-1.179-1.179V9.25A1.194 1.194 0 014.535 8.07h14.928a1.194 1.194 0 011.179 1.179v.785z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
